import { Parametrized } from '@flippingbook/web.utils/dist/service';

export type IOptionsService = {
    [Property in Required<keyof LoginModel> as `get${Capitalize<Property>}`]: () => LoginModel[Property];
} & {
    resetExternalLoginFailureReason: () => void;
};

export class OptionsService extends Parametrized<LoginModel> implements IOptionsService {
    private q: LoginModel['QueryArgs'] = JSON.parse((this.params?.QueryArgs as unknown as string) || '{}');

    getAppId() {
        return this.params.AppId;
    }

    getDesign() {
        return this.params.Design;
    }

    getTokenType() {
        return this.params.TokenType;
    }

    getExternalLoginFailureReason() {
        return this.params.ExternalLoginFailureReason;
    }

    resetExternalLoginFailureReason() {
        this.params.ExternalLoginFailureReason = '';
    }

    getQueryArgs() {
        return this.q;
    }

    getCaptchaRequired() {
        return this.params.CaptchaRequired;
    }

    getError() {
        return this.params.Error;
    }
}
